import { render, staticRenderFns } from "./pay4me.vue?vue&type=template&id=71c04af6&scoped=true&"
import script from "./pay4me.vue?vue&type=script&lang=js&"
export * from "./pay4me.vue?vue&type=script&lang=js&"
import style0 from "./pay4me.vue?vue&type=style&index=0&id=71c04af6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c04af6",
  null
  
)

export default component.exports